import { OrderPaymentStatus } from "@/enums/orders/OrderPaymentStatus"
import { useAxios } from "./useAxios"
import { Pagination } from "@/interfaces/Pagination"
import { Order } from "@/interfaces/orders/Order"
import { OrderSummary } from "@/interfaces/orders/OrderSummary"
import { OrderReports } from "@/interfaces/orders/OrderReports"

export interface GetAllOrdersParams {
  page?: string
  perPage?: string
  from?: Date
  to?: Date
  paymentStatus?: OrderPaymentStatus
  botId?: number
}

export interface GetOrderReportsParams {
  botId?: number
  flowId?: number
  date?: { start: Date, end: Date }
}

const axios = useAxios()

export function useOrder() {
  const getAll = async (params?: GetAllOrdersParams): Promise<Pagination<Order>> => {
    if (params) {
      params = Object.fromEntries(
        Object.entries(params).filter(([param, value]) => !!value)
      )
    }

    const response = await axios.get('/orders', { params })

    return response.data
  }

  const getSummary = async (params?: { botId?: number }): Promise<OrderSummary> => {
    const response = await axios.get('/orders/summary', { params })

    return response.data
  }

  const getReports = async (params?: GetOrderReportsParams): Promise<OrderReports> => {
    const response = await axios.get('/orders/reports', { params })

    return response.data
  }

  return {
    getAll,
    getSummary,
    getReports
  }
}
